import React from 'react';

import styled from 'styled-components';

interface Props {
  bottom?: number;
  color?: string;
}

export const StyledH1 = styled.h1<Props>`
  font-style: normal;
  font-weight: 600;
  font-size: 32px;
  line-height: var(--lineHeightMedium);
  letter-spacing: var(--letterSpacing);
  color: ${({ color }) => color || 'var(--colorBlack)'};
  margin-bottom: ${({ bottom }) => bottom ?? 8}px;
`;

export const StyledH2 = styled.h2<Props>`
  font-style: normal;
  font-weight: 600;
  font-size: 24px;
  line-height: var(--lineHeightMedium);
  letter-spacing: var(--letterSpacing);
  color: ${({ color }) => color || 'var(--colorBlack)'};
  margin-bottom: ${({ bottom }) => bottom ?? 8}px;
`;

export const StyledH3 = styled.h3<Props>`
  font-style: normal;
  font-weight: 600;
  font-size: 20px;
  line-height: var(--lineHeightMedium);
  letter-spacing: var(--letterSpacing);
  color: ${({ color }) => color || 'var(--colorBlack)'};
  margin-bottom: ${({ bottom }) => bottom ?? 8}px;
`;

export const StyledH4 = styled.h4<Props>`
  font-style: normal;
  font-weight: 600;
  font-size: 16px;
  line-height: var(--lineHeightLarge);
  letter-spacing: var(--letterSpacing);
  color: ${({ color }) => color || 'var(--colorBlack)'};
  margin-bottom: ${({ bottom }) => bottom ?? 8}px;
`;

export const StyledH5 = styled.h5<Props>`
  font-style: normal;
  font-weight: 600;
  font-size: 14px;
  line-height: var(--lineHeightSmall);
  letter-spacing: var(--letterSpacing);
  color: ${({ color }) => color || 'var(--colorBlack)'};
  margin-bottom: ${({ bottom }) => bottom ?? 8}px;
`;

export const StyledH6 = styled.h6<Props>`
  font-style: normal;
  font-weight: 600;
  font-size: 12px;
  line-height: var(--lineHeightMedium);
  letter-spacing: var(--letterSpacing);
  color: ${({ color }) => color || 'var(--colorBlack)'};
  margin-bottom: ${({ bottom }) => bottom ?? 8}px;
`;
